import { Theme } from '@material-ui/core';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function componentWithStyles({ palette, spacing, typography }: Theme) {
    const gutterPxSm = spacing(1);

    return {
        systemCard: {
            backgroundColor: palette.background.default,
            margin: gutterPxSm,
        },
        systemCardBody: {},
        systemBodyText: {
            '& * a': {
                ...typography.button,
            },
            '& p': {
                ...typography.caption,
            },
            '& p:first-child': {
                marginTop: 0,
            },
            '& p:last-child': {
                marginBottom: 0,
            },
        },
        systemCardContent: {
            '&:last-child': {
                padding: spacing(2),
            },
        },
        systemCardContainer: {
            display: 'flex',
            flexFlow: 'row nowrap',
            justifyContent: 'flex-start',
        },
        inlineButton: {
            background: 'none',
            border: 'none',
            padding: 0,
            color: '#069',
            textDec: 'underline',
            cursor: 'pointer',
            'text-decoration': 'underline',
        },
    };
}